export const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
